// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--8acbb";
export var productCol = "footer-module--product-col--40362";